window.__esCreateBundleId =
  window.__esCreateBundleId ||
  (() => `${Date.now()}${Math.floor(Math.random() * 1000000).toString().padStart(6, '0')}`);

class MonogramDrawer extends HTMLElement {
    constructor() {
      super();
      
        this.monogramBtn = document.querySelector("[js-monogram-btn]");
        this.closeBtns = this.querySelectorAll("[js-close-drawer]");
        this.drawerOverlay = this.querySelector("[js-drawer-overlay]");
        this.monogramCanvas = this.querySelector("[js-monogram-canvas]");
        this.baseX = parseInt(this.monogramCanvas.getAttribute("data-x-position"));
        this.monogramId = this.querySelector("[js-monogram-product-id]");
        this.monogramInputField = this.querySelector("[js-monogram-input-field]");
        this.characterCountEl = this.querySelector("[js-character-count");
        this.monogramCheckbox = this.querySelector("[js-monogram-checkbox]");
        this.addButton = this.querySelector("[js-monogram-add-btn]");
        this.submitButton = this.querySelector("[js-monogram-submit-btn]");
        this.monogramForm = this.querySelector("[js-monogram-form]");
        this.monogramCharges = this.querySelector("[js-monogram-charges]");
        this.monogramCharacters = this.querySelector("[js-monogram-characters]");
        this.monogramField = this.querySelector("[js-monogram-field]");
        this.monogramPreviewImage = this.querySelector("[js-monogram-preview-image]");
        this.monogramReference = this.querySelectorAll("[js-monogram-reference]");
        this.monogramBundle = this.querySelectorAll("[js-monogram-bundle]");
        this.spinner = this.querySelector(".loading-overlay__spinner");
        this.erroMessage = this.querySelector("[js-error-message]");
        this.maxCharactersText = this.querySelector("[js-max-characters-text]");
        this.monogramPrices = this.querySelectorAll("[js-monogram-price]");
        this.monogramcomparePrices = this.querySelectorAll("[js-monogram-compare-price]");
        this.totalPrice = this.querySelector("[js-total-price]");
        this.monogramVariant = this.querySelector("[js-monogram-variant]");
        this.monogramProductQty = this.querySelector("[js-monogram-product-quantity]");
        this.acknowledgmentInfo = this.querySelector("[js-acknowledgment-info]");
        this.acknowledgmentNote = this.querySelector("[js-acknowledgment-note]");
        this.drawerTitle = this.querySelector("[js-drawer-title]");
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.lineProperties = null;
        this.maxLengthchar =  this.querySelector("[js-max-character]");
        this.minLengthchar =  this.querySelector("[js-min-character]");
        this.openedFromPdp = false;


        this.init();
        this.initComboWidgetSelector();
        document.addEventListener("quick-shop-monogram-btn:init", ({ detail: { variantId }}) => {
            this.initMonogramBtnOnQuickAddToCart(variantId)
        })
        document.addEventListener("monogram-btn:init", () => {
            const monogramBtn = document.querySelector("[js-monogram-btn]");
            monogramBtn?.addEventListener('click', this.open.bind(this));
        });

        document.addEventListener("combo-widget-selector:init", this.initComboWidgetSelector.bind(this))
    }

    init() {
        this.monogramBtn?.addEventListener('click', this.open.bind(this));
        this.closeBtns.forEach( btn => btn.addEventListener("click", this.close.bind(this)));
        this.drawerOverlay.addEventListener('click', this.close.bind(this));
        this.monogramInputField.addEventListener("input", this.handleMonogram.bind(this));
        this.monogramCheckbox.addEventListener("change", this.updateSubmitButton.bind(this));
        this.monogramForm.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.addButton.addEventListener("click", this.handleComboMonogramming.bind(this));

        this.defaultAcknowledgment();
    };

    initComboWidgetSelector() {
        this.giftWidget = document.querySelector("gift-widget");
        this.monogramComboCharacters = this.giftWidget?.querySelector("[js-monogram-combo-characters]");
        this.monogramComboField = this.giftWidget?.querySelector("[js-monogram-combo-field]");
        this.monogramComboBtn = this.giftWidget?.querySelector("[js-monogram-btn]");
        this.monogramComboReference = this.giftWidget?.querySelectorAll("[js-combo-reference-field]");
        this.bundId = this.giftWidget?.querySelectorAll("[js-bundle-id]");
        this.monogramComboFields = this.giftWidget?.querySelectorAll("[js-monogram-combo-field]");
        const comboFormId = this.monogramComboField?.getAttribute("form");
        this.monogramDefaultBlockFields = comboFormId
            ? document.querySelectorAll(`#${comboFormId} [js-monogram-default-block-field]`)
            : [];
        this.monogramInitials = this.giftWidget?.querySelector("[js-monogram-initials]");
    }

    initMonogramBtnOnQuickAddToCart(id) {
        const quickAddModal = document.querySelector(".quick-add-modal[open]");
        const monogramBtn = quickAddModal.querySelector("[js-monogram-btn]");
        monogramBtn?.addEventListener('click', this.open.bind(this));
        this.setAttribute("data-variant-id", id);
    };

    open({currentTarget}) {
        if(currentTarget.classList.contains("is-remove")) return;

        this.openedFromPdp = this.isPdpTrigger(currentTarget);
        
        document.body.classList.add("overflow-hidden");
        if (this.openedFromPdp) {
            document.body.classList.add("pdp-drawer-open");
        }
        this.classList.add("is-open");
        this.cart.close(true);

        const nextEl = currentTarget.nextElementSibling;
        if(nextEl.getAttribute("id") === "monogramJsonData") {
            const monogramObj = JSON.parse(nextEl.textContent);
            this.renderLineItemContents(currentTarget, monogramObj)
        }
        this.lineProperties = this.getLineItemProperties(currentTarget);
        document.documentElement.style.setProperty('--font-monogram', this.monogramCanvas.dataset.fontFamily);
    };

    close() {
        document.body.classList.remove("overflow-hidden");
        document.body.classList.remove("pdp-drawer-open");
        this.classList.remove("is-open");
        this.openedFromPdp = false;

        const canvaContext = this.monogramCanvas.getContext("2d");
        canvaContext.clearRect(0, 0, this.monogramCanvas.width, this.monogramCanvas.height);
        this.monogramInputField.value = "";
        this.monogramCheckbox.checked = false;
        this.submitButton.setAttribute('disabled', 'disabled');
        this.addButton.setAttribute('disabled', 'disabled');
    };

    isPdpTrigger(trigger) {
        if (!trigger?.closest) return false;
        return Boolean(trigger.closest("[js-main-product]")) && !trigger.closest(".quick-add-modal");
    }

    handleMonogram({ target }) {
        this.filterAlphabets();
        this.updateCharacterCount();
        this.updateMonogramPreview();
        this.updatesMonogramInputField(target);
        this.updateSubmitButton();
    };

    filterAlphabets() {
        const filteredValue = this.monogramInputField.value.replace(/[^a-zA-Z]/g, '');
        this.monogramInputField.value = filteredValue;

       //============= NEW FOR CAPITALISE
       if(this.monogramInputField.classList.contains("text-capitalise")) {
          this.monogramInputField.value = filteredValue.charAt(0).toUpperCase() + filteredValue.slice(1).toLowerCase();
       }
      
    };

    updateCharacterCount() {
        this.characterCountEl.innerText = this.monogramInputField.maxLength - this.monogramInputField.value.length;
    };

    updateDrawerTitle(title) {
        this.drawerTitle.innerText = title?.trim() ? title : "Personalise With Initials";
    };

    updateMonogramPreview() {
        const currentLength = this.monogramInputField.value.length;
        const maxLength = this.monogramInputField.maxLength;
        const offset = 5;
        
        let xPos = this.baseX + offset * (maxLength - currentLength);
        if(currentLength > 1) {
            if(this.monogramInputField.value.includes("j") || this.monogramInputField.value.includes("i")) {
                xPos = this.baseX + (offset * (maxLength - currentLength)) + 5.5;
            }
        }
        this.monogramCanvas.setAttribute("data-x-position", xPos);
      
        const data = this.monogramCanvas.dataset;
        const canvaContext = this.monogramCanvas.getContext("2d");
        canvaContext.clearRect(0, 0, this.monogramCanvas.width, this.monogramCanvas.height),
        canvaContext.font = "".concat(data.fontSize, "px ").concat(data.fontFamily),
        canvaContext.textBaseline = "top",
        canvaContext.fillStyle = data.monogramColor;
        canvaContext.fillText(data.textTransform === "uppercase" ? this.monogramInputField.value.toUpperCase() : this.monogramInputField.value.toLowerCase(), data.xPosition, data.yPosition);
        const textWidth = canvaContext.measureText(this.monogramInputField.value).width;
    };

    defaultAcknowledgment() {
        const acknowledgment = JSON.parse(document.querySelector("#defaultAcknowledgementJsonData").textContent);

        this.defaultAcknowledgmentInfo = acknowledgment.info;
        this.defaultAcknowledgmentNote = acknowledgment.note;
    }

    updateAcknowledgment(acknowledgement) {
        if(acknowledgement) {
            this.acknowledgmentInfo.innerHTML = acknowledgement.info;
            this.acknowledgmentNote.innerHTML = acknowledgement.note;
        }else {
            this.acknowledgmentInfo.innerHTML = this.defaultAcknowledgmentInfo;
            this.acknowledgmentNote.innerHTML = this.defaultAcknowledgmentNote;
        }
    }

    updatesMonogramInputField(input) {
        this.monogramField.value = input.classList.contains("text-uppercase") ? this.monogramInputField.value.toUpperCase() : this.monogramInputField.value;
        this.monogramCharacters.value = `${this.monogramField.getAttribute("data-monogram-key")}:${input.classList.contains("text-uppercase") ? this.monogramInputField.value.toUpperCase() : this.monogramInputField.value}`;
        const addedInitialsLabel = this.monogramInitials?.getAttribute("data-initial-added-label");


        if(this.monogramComboField) {
            this.monogramComboField.value = input.classList.contains("text-uppercase") ? this.monogramInputField.value.toUpperCase() : this.monogramInputField.value;
        };

        if(this.monogramComboCharacters) {
            this.monogramComboCharacters.value = `${this.monogramField.getAttribute("data-monogram-key")}:${input.classList.contains("text-uppercase") ? this.monogramInputField.value.toUpperCase() : this.monogramInputField.value}`;

            if(this.monogramInitials && addedInitialsLabel) {
                this.monogramInitials.innerHTML = `${addedInitialsLabel} <span>${input.classList.contains("text-uppercase") ? this.monogramInputField.value.toUpperCase() : this.monogramInputField.value}</span>`;
            }
        }

        //============= NEW FOR CAPITALISE
        if(input.classList.contains("text-capitalise")) {
            this.monogramField.value = this.monogramInputField.value.charAt(0).toUpperCase() + this.monogramInputField.value.slice(1).toLowerCase();
            this.monogramCharacters.value = `${this.monogramField.getAttribute("data-monogram-key")}:${this.monogramInputField.value.charAt(0).toUpperCase() + this.monogramInputField.value.slice(1).toLowerCase()}`;

            if(this.monogramComboField) {
               this.monogramComboField.value = this.monogramInputField.value.charAt(0).toUpperCase() + this.monogramInputField.value.slice(1).toLowerCase();
            };

            if(this.monogramComboCharacters) {
                this.monogramComboCharacters.value = `${this.monogramField.getAttribute("data-monogram-key")}:${this.monogramInputField.value.charAt(0).toUpperCase() + this.monogramInputField.value.slice(1).toLowerCase()}`;
            }

            if(this.monogramInitials && addedInitialsLabel) {
                this.monogramInitials.innerHTML = `${addedInitialsLabel} <span>${this.monogramInputField.value.charAt(0).toUpperCase() + this.monogramInputField.value.slice(1).toLowerCase()}</span>`;
            }
        }
    };

    updateSubmitButton() {
        if(this.querySelector('[data-hb-min-length]')) {
            const minLength = parseInt(this.querySelector('[data-hb-min-length]').getAttribute('data-hb-min-length'));
            if(this.monogramCheckbox.checked && this.monogramInputField.value.length >= minLength) {
                this.submitButton.removeAttribute("disabled");
                this.addButton.removeAttribute("disabled");
            }else {
                this.submitButton.setAttribute('disabled', 'disabled');
                this.addButton.setAttribute('disabled', 'disabled');
            }
        } else {
            if(this.monogramCheckbox.checked && this.monogramInputField.value.length) {
                this.submitButton.removeAttribute("disabled");
                this.addButton.removeAttribute("disabled");
            }else {
                this.submitButton.setAttribute('disabled', 'disabled');
                this.addButton.setAttribute('disabled', 'disabled');
            }
        }
        if(this.querySelector('[js-monogram-input-field]')){
          const maxLength = parseInt(this.querySelector("[js-max-character]").innerText);
          const minLength = parseInt(this.querySelector("[js-min-character]").innerText);
          if(this.monogramCheckbox.checked && this.monogramInputField.value.length > maxLength) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.addButton.setAttribute('disabled', 'disabled');
          }
          if(this.monogramCheckbox.checked && this.monogramInputField.value.length < minLength) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.addButton.setAttribute('disabled', 'disabled');
          }
        }else {
            if(this.monogramCheckbox.checked && this.monogramInputField.value.length) {
                this.submitButton.removeAttribute("disabled");
                this.addButton.removeAttribute("disabled");
            }else {
                this.submitButton.setAttribute('disabled', 'disabled');
                this.addButton.setAttribute('disabled', 'disabled');
            }
        }
      
    };

    onSubmitHandler(evt) {
        evt.preventDefault();

        this.spinner.classList.remove("hidden");

        if(this.dataset.type === "product") {
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const referenceTime = +new Date();
            const bundleId = window.__esCreateBundleId();

            this.monogramReference.forEach( reference => {
                reference.value = referenceTime;
            });
            this.monogramBundle.forEach(bundle => {
                bundle.value = bundleId;
            });
    
            const formData = new FormData(this.monogramForm);
            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;
            fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              if(response.status === 422 || response.status === 'bad_request') {
                  this.handleErrorMessage(response);
              }else {
                this.close();
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.spinner.classList.add('hidden');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            });
        }else {
            this.performCartMonogram();
        }
    };

    async performCartMonogram() {
        const referenceTime = +new Date();
        const bundleId = window.__esCreateBundleId();
        const existingProperties = this.lineProperties ? { ...this.lineProperties } : {};
        const data = {
            line: this.monogramId.getAttribute("data-line-index"),
            quantity: this.monogramProductQty.value,
            properties: existingProperties,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
        };
        const maxLength = parseInt(this.querySelector("[js-max-character]").innerText);
        const minLength = parseInt(this.querySelector("[js-min-character]").innerText);
        if(this.monogramInputField.value.length > maxLength){
          this.monogramInputField.value = this.monogramInputField.value.substring(0, maxLength);
        }
        if (this.monogramPreviewImage?.value) {
            data.properties["_mono_preview_image"] = this.monogramPreviewImage.value;
        }
        data.properties["_isMonogram_dev"] = "true";
        data.properties["_monogramCharges"] = this.getAttribute("data-monogramming-charges");
        data.properties["_mgLetters"] = this.monogramCharacters.value;
        data.properties["_mgId"] = this.monogramVariant.value;
        data.properties["_mgblock"] = "true";
        data.properties[this.monogramField.getAttribute("data-monogram-key")] = this.monogramField.value;
        data.properties["_pc_pricing_ref"] = referenceTime;
        data.properties["_bundle_id"] = bundleId;
        data.properties["_isMonogramDiscount"] = this.getAttribute("data-is-discount");
        data.properties["_monogramDiscount"] = this.getAttribute("data-discount");

        if (this.monogramId.hasAttribute("data-wrist-id")) {
            data.properties["_isWristStrap_dev"] = 'true';
            data.properties["_wristStrapCharges"] = this.monogramId.getAttribute("data-wrist-charges");
            data.properties["_wristId"] = this.monogramId.getAttribute("data-wrist-id");
            data.properties["_isStrapDiscount"] = this.monogramId.getAttribute("data-is-strap-discount");
            data.properties["_strapDiscount"] = this.monogramId.getAttribute("data-strap-discount");
            data.properties["_bundle_id"] = bundleId;
        };
        if (this.monogramId.hasAttribute("data-gift-box-id")) {
            data.properties["_isGiftBox_dev"] = 'true';
            data.properties["_giftBoxCharges"] = this.monogramId.getAttribute("data-gift-box-charges");
            data.properties["_giftBoxId"] = this.monogramId.getAttribute("data-gift-box-id");
            data.properties["_isGiftDiscount"] = this.monogramId.getAttribute("data-is-gift-discount");
            data.properties["_giftDiscount"] = this.monogramId.getAttribute("data-gift-discount");
        };

        const changeRequestBody = JSON.stringify(data);

        // const addRequestBody = JSON.stringify({
        //     id: this.monogramVariant.value,
        //     quantity: this.monogramProductQty.value,
        //     sections: this.cart.getSectionsToRender().map((section) => section.id),
        //     sections_url: window.location.pathname,
        //     properties: {
        //         _pc_pricing_ref: referenceTime
        //     },
        // });
        
        try {
            const firstResponse = await fetch(`${routes.cart_change_url}`,{ ...fetchConfig(), ...{ body: changeRequestBody }});
            const firstData = await firstResponse.json();

            this.spinner.classList.add("hidden");
            this.cart.renderContents(firstData);
            this.close();
        
            // const secondResponse = await fetch(`${routes.cart_add_url}`,{ ...fetchConfig(), ...{ body: addRequestBody }});
            // const secondData = await secondResponse.json();

            // this.cart.renderContents(secondData);
      
        } catch (error) {
            this.handleErrorMessage(error);
        }
    };

    getLineItemProperties(triggerButton) {
        try {
            const lineItemRow = triggerButton.closest('tr');
            if (!lineItemRow) return null;
            const propertiesNode = lineItemRow.querySelector('#propertiesJsonData');
            if (!propertiesNode) return null;
            return JSON.parse(propertiesNode.textContent || '{}');
        } catch (error) {
            console.warn('Unable to parse line item properties for monogram drawer', error);
            return null;
        }
    }

    handleErrorMessage(response) {
        this.erroMessage.innerText = response.description;
        this.erroMessage.classList.remove("hidden");

        setTimeout(() => {
            this.erroMessage.innerText = "";
            this.erroMessage.classList.add("hidden");
        }, 3000)
    };

    renderLineItemContents(btn, obj) {
        this.setAttribute("data-type", btn.dataset.type);
        this.setAttribute("data-monogramming-charges", obj.additional_charge_pence / 100);
        if(this.getAttribute("data-type") === "product" ) {
            this.monogramForm.classList.remove("hidden");
            this.addButton.classList.remove("hidden");

            const currentVariant = this.getCurrentVariantData(parseInt(this.getAttribute("data-variant-id")));

            if(currentVariant) {
                if(window.igData?.price?.getPriceByVariantId(obj.monogram_variant)) {
                    const monogramPrice = parseInt(`${window.igData?.price?.getPriceByVariantId(obj.monogram_variant)}00`);
                    this.totalPrice.innerText = `${this.getAttribute("data-currency-symbol")}${(currentVariant.price + monogramPrice) / 100}`
                }else {
                    this.totalPrice.innerText = `${this.getAttribute("data-currency-symbol")}${(currentVariant.price + obj.additional_charge_pence) / 100}`;
                }

                if(currentVariant.featured_image?.src) {
                    this.monogramCanvas.style.backgroundImage = `url('${currentVariant.featured_image.src}')`;
                }
                this.monogramId.value = currentVariant.id;
            }
        }else {
            this.monogramForm.classList.remove("hidden");
            this.addButton.classList.add("hidden");

            if(window.igData?.price?.getPriceByVariantId(obj.monogram_variant)) {
                const monogramPrice = parseInt(`${window.igData?.price?.getPriceByVariantId(obj.monogram_variant)}00`);
                this.totalPrice.innerText = `${this.getAttribute("data-currency-symbol")}${(parseInt(obj.line_item_price) + monogramPrice) / 100}`;
            }else {
                this.totalPrice.innerText = obj.total_price;
            }
            
            this.monogramCanvas.style.backgroundImage = `url('${obj.monogram_image}')`;
            this.monogramId.value = obj.monogram_id;
            this.monogramId.setAttribute("data-line-index", btn.getAttribute("data-index"));
            if(btn.getAttribute("data-wrist-id")) {
                this.monogramId.setAttribute("data-wrist-id", btn.getAttribute("data-wrist-id"));
                this.monogramId.setAttribute("data-wrist-charges", btn.getAttribute("data-wrist-charges"));
                this.monogramId.setAttribute("data-is-strap-discount", btn.getAttribute("data-is-strap-discount"));
                this.monogramId.setAttribute("data-strap-discount", btn.getAttribute("data-strap-discount"));
            }else {
                this.monogramId.removeAttribute("data-wrist-id");
                this.monogramId.removeAttribute("data-wrist-charges");
                this.monogramId.removeAttribute("data-is-strap-discount");
                this.monogramId.removeAttribute("data-strap-discount");
            };

            if(btn.getAttribute("data-gift-box-id")) {
                this.monogramId.setAttribute("data-gift-box-id", btn.getAttribute("data-gift-box-id"));
                this.monogramId.setAttribute("data-gift-box-charges", btn.getAttribute("data-gift-box-charges"));
                this.monogramId.setAttribute("data-is-gift-discount", btn.getAttribute("data-is-gift-discount"));
                this.monogramId.setAttribute("data-gift-discount", btn.getAttribute("data-gift-discount"));
            }else {
                this.monogramId.removeAttribute("data-gift-box-id");
                this.monogramId.removeAttribute("data-gift-box-charges");
                this.monogramId.removeAttribute("data-is-gift-discount");
                this.monogramId.removeAttribute("data-gift-discount");
            }
        }

        this.buildCustomImage(obj.monogram_custom_image);
        const field_text_transform = obj.metafields.font_lowercase ? "lowercase" : "uppercase";

        const field_text_transform_new = obj.metafields.font_capitalise;
      
        this.monogramProductQty.value = btn.getAttribute("data-line-item-qty");
        this.monogramCharges.value = obj.additional_charge_pence / 100;
        const monogramCharactersText = obj.is_full_name
            ? 'nine letters'
            : obj.metafields.max_characters_text;
        const monogramPropertyKey = `Add up to ${monogramCharactersText}`;
        this.monogramField.name = `properties[${monogramPropertyKey}]`;
        this.monogramField.setAttribute("data-monogram-key", monogramPropertyKey);
        if (this.monogramPreviewImage) {
            this.monogramPreviewImage.value = obj.metafields.mono_preview_image || "";
        }
        this.maxCharactersText.innerText = monogramCharactersText;
        this.characterCountEl.innerText = obj.metafields.max_characters_number;
        this.maxLengthchar.innerText = obj.metafields.max_characters_number;
        this.minLengthchar.innerText = obj.metafields.min_length;
        this.monogramInputField.placeholder = obj.metafields.slider_placeholder_text;
        this.monogramInputField.maxLength = obj.metafields.max_characters_number;
        this.monogramVariant.value = obj.monogram_variant;

        this.monogramInputField.setAttribute('data-hb-min-length', obj.metafields.min_length);

        this.querySelector('[js-hb-initials-text]').innerText = obj.metafields.initials_text;

        if(obj.metafields.initials_text) {
           this.querySelector('[js-hb-without-initials-text-wrapper]').style.display = 'none';
           this.querySelector('[js-hb-initials-text-wrapper]').style.display = 'flex';
        } else {
           this.querySelector('[js-hb-initials-text-wrapper]').style.display = 'none';
           this.querySelector('[js-hb-without-initials-text-wrapper]').style.display = 'flex';
        }

        if(field_text_transform === "uppercase") {
            this.monogramInputField.classList.add('text-uppercase');
            this.monogramInputField.classList.remove('text-lowercase');
        }else {
            this.monogramInputField.classList.add('text-lowercase');
            this.monogramInputField.classList.remove('text-uppercase');
        }

          //============= NEW FOR CAPITALISE
         
          if(field_text_transform_new) {
              this.monogramInputField.classList.add('text-capitalise');
          }
      
        if(window.igData?.price?.getPriceByVariantId(obj.monogram_variant)) {
            this.monogramPrices.forEach((monogramPrice) => {
                monogramPrice.innerText = `${this.getAttribute("data-currency-symbol")}${window.igData?.price?.getPriceByVariantId(obj.monogram_variant)}`
            })
        } else {
          if(obj.monogram_price_zero == 0){
            this.monogramPrices.forEach((monogramPrice) => {
                monogramPrice.innerText = "FREE";
            })
            
          }
          else{
            this.monogramPrices.forEach((monogramPrice) => {
                monogramPrice.innerText = obj.monogram_price;
            })
          }
        }
      if(window.igData?.price?.getComparePriceByVariantId(obj.monogram_variant)) {
        this.monogramcomparePrices.forEach((monogramcomparePrice) => {
              console.log(monogramcomparePrice,'monogramcomparePrices');
                monogramcomparePrice.innerText = `${this.getAttribute("data-currency-symbol")}${window.igData?.price?.getComparePriceByVariantId(obj.monogram_variant)}`
            })
      }else{
        if(obj.monogram_compare_price){
          this.monogramcomparePrices.forEach((monogramcomparePrice) => {
            monogramcomparePrice.innerText = obj.monogram_compare_price;
          })
        }
        
      }

      
        this.monogramCanvas.setAttribute('data-font-family', obj.monogramming.font_family);
        this.monogramCanvas.setAttribute('data-font-size', obj.monogramming.font_size);
        this.monogramCanvas.setAttribute('data-monogram-color', obj.metafields.colour);
        this.monogramCanvas.setAttribute('data-x-position', obj.monogramming.x_position);
        this.monogramCanvas.setAttribute('data-y-position', obj.monogramming.y_position);
        this.monogramCanvas.setAttribute('data-text-transform', field_text_transform);

        this.baseX = obj.monogramming.x_position;

        this.querySelector('[js-hb-monogram-arrow]').style.left = +obj.monogramming.x_position + - 85 + 10 + 'px';
        this.querySelector('[js-hb-monogram-arrow]').style.top = +obj.monogramming.y_position - 60 - 5 + 'px';

        this.updateDrawerTitle(obj.metafields.personalise_with_override);
        this.updateAcknowledgment(obj.acknowledgement);
    }

    getCurrentVariantData(id) {
        // Absent on products with only a default variant - the variant picker isn't rendered.
        const variantDataNode = document.querySelector('[js-variant-data-json]');
        if (!variantDataNode) return null;
        const variantData = JSON.parse(variantDataNode.textContent);
        const currentVariant = variantData.find(variant => variant.id === id);
        return currentVariant;
    }

    buildCustomImage(src) {
        this.querySelector("[js-custom-featured-image]")?.remove();

        if(src) {
            const imgHtml = `
                <div class="custom-img" js-custom-featured-image>
                    <img src="${src}" width="410" height="430">
                </div>
            `;

            this.monogramCanvas.classList.add("hidden");
            this.querySelector('[js-hb-monogram-canvas-wrapper]').insertAdjacentHTML("beforeend", imgHtml);
        }else {
            this.monogramCanvas.classList.remove("hidden");
        }
    }

    handleComboMonogramming() {
        const referenceTime = +new Date();
        const bundleId = window.__esCreateBundleId();
        this.monogramComboReference?.forEach(el => el.value = referenceTime);
        this.bundId?.forEach(el => el.value = bundleId);
        this.monogramComboFields?.forEach(el => el.removeAttribute("disabled"));
        this.monogramDefaultBlockFields?.forEach(el => {
            el.value = "true";
            el.removeAttribute("disabled");
        });
        this.monogramComboBtn.classList.add("has-monogramming");
        this.monogramComboBtn.classList.add("is-remove");

        const handleComboPrice = this.giftWidget?.handlePrice.bind(this.giftWidget);
        handleComboPrice();

        this.close();
    }
}
  
customElements.define('monogram-drawer', MonogramDrawer);
